var map = {
	"./access-active.svg": "b77a",
	"./access.svg": "88eb",
	"./account-active.svg": "c551",
	"./account.svg": "0d02",
	"./admins-active.svg": "6d49",
	"./admins.svg": "5eb9",
	"./candidates-active.svg": "a94b",
	"./candidates.svg": "3bdb",
	"./clients-active.svg": "91d5",
	"./clients.svg": "74ef",
	"./managers-active.svg": "c720",
	"./managers.svg": "6232",
	"./menu.svg": "1bb6",
	"./partners-active.svg": "209a",
	"./partners.svg": "4f0b",
	"./profgrams-active.svg": "490b",
	"./profgrams.svg": "7dc1",
	"./ref-active.svg": "29f1",
	"./ref.svg": "699d",
	"./report-active.svg": "08d2",
	"./report.svg": "4878",
	"./services-active.svg": "f5b2",
	"./services.svg": "2394",
	"./support-active.svg": "9cac",
	"./support.svg": "a915"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e46";